import { useCurrentUser } from '../context/CurrentUserContext';

// Wrap anything that should only render for certain hub roles, e.g.
// <RoleGate allow={['admin']}>...</RoleGate>. Pass `fallback` to render
// an alternative instead of nothing when the role doesn't match.
function RoleGate({ allow, fallback = null, children }) {
  const currentUser = useCurrentUser();
  return allow.includes(currentUser?.hubRole) ? children : fallback;
}

export default RoleGate;
